import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, isRef as _isRef } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "dialog-footer" }

import { computed, ref, PropType, Ref, watch, nextTick } from 'vue'
import { ElDialog } from 'element-plus'
import { useI18n } from 'vue-i18n'
import { upsertStation } from '@/api/operation'
import { ElInput, ElMessage } from 'element-plus'
import { EvseCurrentType, FieldEnable, StationNature } from '@/types/types'
import { splitLastCharacter } from '@/common/tools'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import SelectOperator from '@/components/SelectOperator.vue'
import SwitchLocaltionDialog from '@/components/Maps/SwitchLocaltionDialog.vue'
import InfoTooltip from '@/components/InfoTooltip.vue'
import InputWithUnitNumber from '@/components/InputWithUnitNumber.vue'
import InputStringWithUnit from '@/components/InputStringWithUnit.vue'
import type { UploadProps, UploadUserFile } from 'element-plus'
import { Plus } from '@element-plus/icons-vue'
import AdvancedSettingContainer from '@/components/AdvancedSettingContainer.vue'
import { regionData } from 'element-china-area-data'
import FormRulesFactory from '@/common/formRules'
import { isInChina } from '@/store/tool'
import SelectStationNature from '@/components/SelectStationNature.vue'
import { Country } from '@/types/types'

export type ShowDialogType = 'create' | 'edit'


import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'StationUpsert',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  showType: {
    type: String as PropType<ShowDialogType>,
    required: true,
  },
  showData: {
    type: Object as PropType<Record<string, any>>,
    default: () => {},
  },
},
  emits: ["update:modelValue", "submitted"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: boolean): void
  (e: 'submitted'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

const {
  essGridType,
  country,
  stationTags,
  paymentModeTypes,
  stationType,
  stationConstruction,
  StationStates,
  BusinessStatesTypes,
  evseChargingSpeedType,
  terminnalChannels,
  useVehicleTypes,
  getBusinessStatesTypeDesc,
} = useProtocolEnums()
const { t } = useI18n()
const hasEvseNature = computed(() => {
  return (formData.value.stationNature & StationNature.SN_EVSE) == StationNature.SN_EVSE
  // return true
})

const hasPvesOrEssNature = computed(
  () =>
    (formData.value.stationNature & StationNature.SN_PVES) == StationNature.SN_PVES ||
    (formData.value.stationNature & StationNature.SN_ESS) == StationNature.SN_ESS,
)

const contactType = ref()
// 省市区数据
const regionDatas = ref(regionData)
const regionDataList = ref<string[]>()
const handleRegionDataChange = (e: []) => {
  formData.value.areaCode = e[e.length - 1] || ''
}


const covers = ref<UploadUserFile[]>([
  // {
  //   name: '',
  //   url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100',
  // },
  // {
  //   name: '',
  //   url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100',
  // },
])

const dialogImageUrl = ref('')
const dialogVisible = ref(false)

const handleOpenMapsDialog = () => {
  const { areaCode } = formData.value
  console.log(areaCode)
  if (areaCode) {
    showMapsDialog.value = true
  } else {
    ElMessage.error(t('Operation.selectCityCode'))
  }
}
const handleChangeLatLng = (payload: { lat: number; lng: number }) => {
  formData.value.lat = payload.lat
  formData.value.lng = payload.lng
}
const handleRemove: UploadProps['onRemove'] = (uploadFile, uploadFiles) => {
  console.log(uploadFile, uploadFiles)
}

const handlePictureCardPreview: UploadProps['onPreview'] = (uploadFile) => {
  dialogImageUrl.value = uploadFile.url!
  dialogVisible.value = true
}

const handleSuccess: UploadProps['onSuccess'] = (res, uploadFile, uploadFiles) => {
  uploadFile.url = res.files[0]
}

const createRawFormData = () => ({
  essExInfo: {
    totalCapacity: 0,
    gridConnected: false,
    gridTime: '',
    gridType: 0,
  },
  qrcodeTmpl: {
    prefix: '',
  },
})

const showMapsDialog = ref(false)
const formCom = ref()
const formData: Ref<Record<string, any>> = ref(createRawFormData())

const stationFormRules = ref({
  ...FormRulesFactory.generateCustomRules(
    ['operatorID', 'country', 'stationNature'],
    'selectNone',
    'selectNone',
  ),
  ...FormRulesFactory.generateCustomRules(['address'], 'inputEmpty', 'inputInvalid', {
    minLen: 4,
  }),
  ...FormRulesFactory.generateCustomRules(['name'], 'inputEmpty', 'inputInvalid', {
    minLen: 3,
  }),
  ...FormRulesFactory.generateCustomRules(
    ['contactName', 'contactmt', 'evseInfo'],
    'inputEmpty',
    'inputInvalid',
  ),
  ...FormRulesFactory.generateCustomRules(['currentMax'], 'inputEmpty', 'inputInvalid', {
    type: 'number',
    min: 1,
    max: 10000,
  }),
  ...FormRulesFactory.generateCustomRules(['powerMax'], 'inputEmpty', 'inputInvalid', {
    type: 'number',
    min: 1,
    max: 100000,
  }),
  ...FormRulesFactory.generateCustomRules(['lat'], 'inputEmpty', 'inputInvalid', {
    type: 'number',
    min: -90,
    max: 90,
  }),
  ...FormRulesFactory.generateCustomRules(['lng'], 'inputEmpty', 'inputInvalid', {
    type: 'number',
    min: -180,
    max: 180,
  }),
})

const isSubmitting = ref(false)
const showDialog = computed({
  get: () => props.modelValue,
  set: (val: boolean) => {
    emit('update:modelValue', val)
  },
})

watch(showDialog, async (val) => {
  if (val) {
    if (props.showType !== 'create') {
      console.log(props.showData)
      formData.value.id = props.showData?.id
      formData.value.areaCode = props.showData?.areaCode
      formData.value.operatorID = props.showData?.operatorID
      formData.value.name = props.showData?.name
      formData.value.evseNum = props.showData?.evseNum
      formData.value.contactName = props.showData?.contactName
      if (props.showData?.contactPhone != '') {
        formData.value.contactmt = props.showData?.contactPhone + 'p'
      } else {
        formData.value.contactmt = props.showData?.contactEmail + 'e'
      }
      if (props.showData?.evseType > 0) {
        formData.value.evseInfo = props.showData?.evseNum + props.showData?.evseType
      } else {
        formData.value.evseInfo = props.showData?.evseNum + '1'
      }
      formData.value.country = props.showData?.country

      formData.value.streetCode = props.showData?.exInfo.streetCode
      formData.value.org = props.showData?.exInfo.org
      formData.value.meterAccount = props.showData?.exInfo.meterAccount
      formData.value.elecAccount = props.showData?.exInfo.elecAccount
      formData.value.buildTime = props.showData?.exInfo.buildTime
      formData.value.state = props.showData?.exInfo.state || ''
      formData.value.construction = props.showData?.exInfo.construction || ''
      formData.value.type = props.showData?.exInfo.type || ''

      formData.value.parkInfo = props.showData?.parkInfo
      formData.value.address = props.showData?.address
      formData.value.lng = props.showData?.lng
      formData.value.lat = props.showData?.lat
      formData.value.qrcodeTmpl = props.showData?.qrcodeTmpl || {
        prefix: '',
      }
      formData.value.vehicleType = props.showData?.vehicleType

      formData.value.minChargingAmount = props.showData?.minChargingAmount
      formData.value.powerMax = props.showData?.powerMax + 'KW'
      formData.value.currentMax = props.showData?.currentMax + 'A'
      covers.value = []
      props.showData?.covers.forEach((item: any) => {
        covers.value.push({ name: '', url: item })
      })
      formData.value.businessState = props.showData?.businessState
      formData.value.tags = props.showData?.tags
      formData.value.allowFixedAmount = FieldEnable.CES_DISABLE
      formData.value.fixedAmounts = props.showData?.fixedAmounts.join(',')
      formData.value.paymentModeTypes = props.showData?.paymentModeTypes
      formData.value.stationNature = props.showData?.stationNature

      // 添加代码：处理allowChannels为空的情况
      formData.value.allowChannels = props.showData?.allowChannels || [];
      if (formData.value.allowChannels.length === 0) {
        // 如果allowChannels为空，则全选所有终端
        formData.value.allowChannels = terminnalChannels.map(item => item.value);
      }

      if (props.showData?.allowFixedAmount) {
        formData.value.allowFixedAmount = FieldEnable.CES_ENABLE
      } else {
        formData.value.paymentModeTypes = []
      }
      regionDataList.value = (() => {
        const areaCode = props.showData?.areaCode
        if (!areaCode) return []
        return [
          areaCode.substring(0, 2), // 省级代码
          areaCode.substring(0, 4), // 市级代码
          areaCode, // 区级代码
        ]
      })()
    } else {
      console.log('create')
      nextTick(() => {
        formData.value = createRawFormData()
        formCom.value.resetField()
      })
    }
  } else {
    // formData.value = createRawFormData()
  }
})

function isFixedAmounts(input: string): boolean {
  // 使用正则表达式检查输入格式
  const regex = /^\d+(\.\d+)?(,\d+(\.\d+)?)*$/
  return regex.test(input)
}

const submit = async () => {
  console.log('submit')
  try {
    await formCom.value.validate()
    if (isInChina()) {
      formData.value.country = Country.CY_CHINA
    }
    const { meterAccount, elecAccount, buildTime, state, streetCode, construction, type, org } =
      formData.value
    const params = {
      ...formData.value,
    }
    isSubmitting.value = true
    if (hasEvseNature.value) {
      const contactmt = splitLastCharacter(params.contactmt, 1)
      if (contactmt.lastChar === 'p') {
        params.contactPhone = contactmt.beforeLast
      } else {
        params.contactEmail = contactmt.beforeLast
      }
      const evseInfo = splitLastCharacter(params.evseInfo, 1)
      params.evseNum = evseInfo.beforeLast
      params.evseType = Number(evseInfo.lastChar)
      const currentMax = splitLastCharacter(params.currentMax, 1)
      params.currentMax = Number(currentMax.beforeLast)
      const powerMax = splitLastCharacter(params.powerMax, 2)
      params.powerMax = Number(powerMax.beforeLast)
      params.covers = []
      covers.value.forEach((item) => {
        params.covers.push(item.url)
      })
      if (params.fixedAmounts && params.fixedAmounts != '') {
        if (!isFixedAmounts(params.fixedAmounts)) {
          ElMessage.error(t(`Operation.fixedAmountsFormatError`))
          return
        }

        params.fixedAmounts = params.fixedAmounts.split(',').map(Number)
        if (params.fixedAmounts.length === 0) {
          ElMessage.error(t(`Operation.fixedAmountsEmpty`))
          return
        }
      } else {
        params.fixedAmounts = []
      }
      // 添加充电类型处理
      if (params.chargingSpeedType) {
        params.chargingSpeedType = Number(params.chargingSpeedType)
      } else {
        params.chargingSpeedType = 0 // 默认未知类型
      }
    }

    await upsertStation({
      ...params,
      exInfo: {
        meterAccount,
        elecAccount,
        buildTime,
        construction: construction || 0,
        type: type || 0,
        state: state || 0,
        org,
        streetCode,
      },
    })
    if (props.showType === 'edit') {
      ElMessage.success(t(`Base.updateSuccess`))
    } else {
      ElMessage.success(t(`Base.createSuccess`))
    }
    emit('submitted')
    showDialog.value = false
  } catch (error) {
    console.log(error)
  } finally {
    isSubmitting.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_drawer, {
      title: props.showType == 'create' ? _unref(t)('Operation.addStation') : _unref(t)('Operation.editStation'),
      modelValue: _unref(showDialog),
      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
      "lock-scroll": false,
      "close-on-click-modal": true,
      size: "50%",
      "z-index": 1999,
      "custom-class": "evse-drawer"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_el_button, {
            onClick: _cache[39] || (_cache[39] = ($event: any) => (showDialog.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Base.cancel')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: submit,
            disabled: !_ctx.$hasPermission('post'),
            loading: isSubmitting.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Base.confirm')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "formCom",
          ref: formCom,
          "label-position": "top",
          "require-asterisk-position": "right",
          model: formData.value,
          rules: stationFormRules.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('Operation.operator'),
                      prop: "operatorID",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(SelectOperator, {
                          modelValue: formData.value.operatorID,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.operatorID) = $event)),
                          disabled: props.showType == 'create' ? false : true
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('Base.name'),
                      prop: "name",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ElInput), {
                          modelValue: formData.value.name,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.name) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('Base.stationNature'),
                      prop: "stationNature",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(SelectStationNature, {
                          modelValue: formData.value.stationNature,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.stationNature) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('Operation.contacts'),
                      prop: "contactName",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ElInput), {
                          modelValue: formData.value.contactName,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.contactName) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('Operation.contactmt'),
                      prop: "contactmt",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(InputStringWithUnit, {
                          modelValue: formData.value.contactmt,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.contactmt) = $event)),
                          isPrepend: true,
                          isString: true,
                          units: [
                { label: 'Phone', value: 'p' },
                { label: 'Email', value: 'e' },
              ]
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                (_unref(hasPvesOrEssNature))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _unref(t)('Operation.gridConnected'),
                            prop: "essExInfo.gridConnected"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_switch, {
                                modelValue: formData.value.essExInfo.gridConnected,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.essExInfo.gridConnected) = $event)),
                                class: "mb-2"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _unref(t)('Operation.totalCapacity'),
                            prop: "essExInfo.totalCapacity",
                            required: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(InputWithUnitNumber, {
                                modelValue: formData.value.essExInfo.totalCapacity,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.essExInfo.totalCapacity) = $event)),
                                units: [{ label: 'kWp', value: '' }]
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      (formData.value.essExInfo.gridConnected)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: _unref(t)('Operation.gridTime'),
                                  prop: "essExInfo.gridTime",
                                  required: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_date_picker, {
                                      modelValue: formData.value.essExInfo.gridTime,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.essExInfo.gridTime) = $event)),
                                      type: "datetime",
                                      format: "YYYY/MM/DD hh:mm:ss",
                                      "value-format": "YYYY-MM-DD h:m:s "
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: _unref(t)('Operation.gridType'),
                                  prop: "essExInfo.gridType",
                                  required: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: formData.value.essExInfo.gridType,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.essExInfo.gridType) = $event))
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(essGridType), (gridType) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: gridType.value,
                                            label: gridType.label,
                                            value: gridType.value
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            })
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (_unref(hasEvseNature))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _unref(t)('Evses.maxCurrent'),
                            prop: "currentMax",
                            required: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(InputWithUnitNumber, {
                                modelValue: formData.value.currentMax,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.currentMax) = $event)),
                                units: [{ label: 'A', value: 'A' }]
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _unref(t)('Evses.maxPower'),
                            prop: "powerMax",
                            required: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(InputWithUnitNumber, {
                                modelValue: formData.value.powerMax,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.powerMax) = $event)),
                                units: [{ label: 'KW', value: 'KW' }]
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _unref(t)('Operation.stationEvseInfo'),
                            prop: "evseInfo",
                            required: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(InputWithUnitNumber, {
                                modelValue: formData.value.evseInfo,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.evseInfo) = $event)),
                                isPrepend: true,
                                numberPlaceholder: _unref(t)('Evses.connectorNum'),
                                units: [
                  { label: _ctx.$t('Operation.stationAC'), value: _unref(EvseCurrentType).ECT_AC.toString() },
                  { label: _ctx.$t('Operation.stationDC'), value: _unref(EvseCurrentType).ECT_DC.toString() },
                  {
                    label: _ctx.$t('Operation.stationDCAC'),
                    value: _unref(EvseCurrentType).ECT_AC_DC.toString(),
                  },
                ]
                              }, null, 8, ["modelValue", "numberPlaceholder", "units"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _unref(t)('Operation.businessState'),
                            prop: "businessState",
                            required: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: formData.value.businessState,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.businessState) = $event)),
                                placeholder: _ctx.$t('Operation.businessState'),
                                clearable: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(BusinessStatesTypes), (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      label: item.label,
                                      value: item.value,
                                      key: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _unref(t)('Operation.chargingSpeedType'),
                            prop: "chargingSpeedType"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: formData.value.chargingSpeedType,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.value.chargingSpeedType) = $event)),
                                placeholder: _ctx.$t('Operation.chargingSpeedType'),
                                clearable: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(evseChargingSpeedType), (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value.toString()
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_divider, {
                      class: "custom-divider",
                      "content-position": "left"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, { type: "text" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('Operation.stationAddress')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, { onClick: handleOpenMapsDialog }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('Operation.selectMapAddress')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (!_unref(isInChina)())
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 0,
                      span: 12
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: _unref(t)('Operation.country'),
                          prop: "country",
                          required: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: formData.value.country,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.value.country) = $event)),
                              clearable: ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(country), (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    label: item.label,
                                    value: item.value,
                                    key: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(isInChina)())
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 1,
                      span: 12
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: _unref(t)('Operation.cityCode'),
                          prop: "areaCode"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_cascader, {
                              options: regionDatas.value,
                              modelValue: regionDataList.value,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((regionDataList).value = $event)),
                              onChange: handleRegionDataChange
                            }, null, 8, ["options", "modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('Operation.address'),
                      prop: "address",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ElInput), {
                          modelValue: formData.value.address,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formData.value.address) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('Operation.lng'),
                      prop: "lng",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ElInput), {
                          modelValue: formData.value.lng,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formData.value.lng) = $event)),
                          modelModifiers: { trim: true }
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('Operation.lat'),
                      prop: "lat",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ElInput), {
                          modelValue: formData.value.lat,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formData.value.lat) = $event)),
                          modelModifiers: { trim: true }
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_unref(hasEvseNature))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(AdvancedSettingContainer, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_el_row, { gutter: 20 }, {
                          default: _withCtx(() => [
                            (!_unref(isInChina)())
                              ? (_openBlock(), _createBlock(_component_el_col, {
                                  key: 0,
                                  span: 12
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_form_item, {
                                      label: _unref(t)('Operation.cityCode'),
                                      prop: "areaCode"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(ElInput), {
                                          modelValue: formData.value.areaCode,
                                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formData.value.areaCode) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }, 8, ["label"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: _unref(t)('Base.tags'),
                                  prop: "tags"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: formData.value.tags,
                                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((formData.value.tags) = $event)),
                                      clearable: "",
                                      multiple: "",
                                      prop: "funcs"
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stationTags), (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            label: item.label,
                                            value: item.value,
                                            key: item.value
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: _unref(t)('Operation.parkInfo'),
                                  prop: "parkInfo"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ElInput), {
                                      rows: 1,
                                      type: "textarea",
                                      modelValue: formData.value.parkInfo,
                                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((formData.value.parkInfo) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, { prop: "allowChannels" }, {
                                  label: _withCtx(() => [
                                    _createElementVNode("label", null, _toDisplayString(_unref(t)('Base.allowApp')), 1)
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: formData.value.allowChannels,
                                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((formData.value.allowChannels) = $event)),
                                      clearable: "",
                                      multiple: "",
                                      prop: "funcs"
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(terminnalChannels), (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            label: item.label,
                                            value: item.value,
                                            key: item.value
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, { prop: "qrcodeTmpl" }, {
                                  label: _withCtx(() => [
                                    _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.opQrcodeFix')), 1),
                                    _createVNode(InfoTooltip, {
                                      content: _ctx.$t('Operation.domainDesc')
                                    }, null, 8, ["content"])
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ElInput), {
                                      modelValue: formData.value.qrcodeTmpl.prefix,
                                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((formData.value.qrcodeTmpl.prefix) = $event)),
                                      placeholder: "https://xxx.xxx.com/qr?biz=lcharge&sn="
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: _unref(t)('Evses.useVehicleType'),
                                  prop: "useVehicleType"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: formData.value.vehicleType,
                                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((formData.value.vehicleType) = $event)),
                                      clearable: ""
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(useVehicleTypes), (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            label: item.label,
                                            value: item.value,
                                            key: item.value
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: _unref(t)('Operation.minChargingAmount'),
                                  prop: "minChargingAmount"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ElInput), {
                                      modelValue: formData.value.minChargingAmount,
                                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((formData.value.minChargingAmount) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 4 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: _unref(t)('Operation.allowFixedAmount'),
                                  prop: "allowFixedAmount"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_switch, {
                                      modelValue: formData.value.allowFixedAmount,
                                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((formData.value.allowFixedAmount) = $event)),
                                      "active-value": _unref(FieldEnable).CES_ENABLE,
                                      "inactive-value": _unref(FieldEnable).CES_DISABLE
                                    }, null, 8, ["modelValue", "active-value", "inactive-value"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            }),
                            (formData.value.allowFixedAmount == _unref(FieldEnable).CES_ENABLE)
                              ? (_openBlock(), _createBlock(_component_el_col, {
                                  key: 1,
                                  span: 10
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_form_item, {
                                      label: _unref(t)('Operation.fixedAmounts'),
                                      prop: "fixedAmounts"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(ElInput), {
                                          modelValue: formData.value.fixedAmounts,
                                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((formData.value.fixedAmounts) = $event)),
                                          placeholder: "5,10,20,50,100"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }, 8, ["label"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (formData.value.allowFixedAmount == _unref(FieldEnable).CES_ENABLE)
                              ? (_openBlock(), _createBlock(_component_el_col, {
                                  key: 2,
                                  span: 10
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_form_item, { prop: "paymentModeTypes" }, {
                                      label: _withCtx(() => [
                                        _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.paymentModeTypes')), 1),
                                        _createVNode(InfoTooltip, {
                                          content: _ctx.$t('Operation.paymentModeTypeDesc')
                                        }, null, 8, ["content"])
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: formData.value.paymentModeTypes,
                                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((formData.value.paymentModeTypes) = $event)),
                                          clearable: "",
                                          multiple: "",
                                          prop: "funcs"
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paymentModeTypes), (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                label: item.label,
                                                value: item.value,
                                                key: item.value
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_col, { span: 24 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: _unref(t)('Operation.covers'),
                                  prop: "covers"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_card, { style: {"width":"100%","min-height":"100px"} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_upload, {
                                          "file-list": covers.value,
                                          "onUpdate:file-list": _cache[29] || (_cache[29] = ($event: any) => ((covers).value = $event)),
                                          action: "/cms/media/upload",
                                          "list-type": "picture-card",
                                          "on-preview": handlePictureCardPreview,
                                          "on-remove": handleRemove,
                                          "on-success": handleSuccess
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_icon, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(Plus))
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["file-list"]),
                                        _createVNode(_unref(ElDialog), {
                                          modelValue: dialogVisible.value,
                                          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((dialogVisible).value = $event))
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("img", {
                                              "w-full": "",
                                              src: dialogImageUrl.value,
                                              alt: "Preview Image"
                                            }, null, 8, _hoisted_1)
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(AdvancedSettingContainer, {
                    title: _ctx.$t('Operation.stationEXInfo')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { gutter: 20 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                label: _unref(t)('Operation.stationType'),
                                prop: "type"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: formData.value.type,
                                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((formData.value.type) = $event)),
                                    clearable: ""
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stationType), (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          label: item.label,
                                          value: item.value,
                                          key: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                label: _unref(t)('Operation.stationConstruction'),
                                prop: "construction"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: formData.value.construction,
                                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((formData.value.construction) = $event)),
                                    clearable: ""
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stationConstruction), (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          label: item.label,
                                          value: item.value,
                                          key: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                label: _unref(t)('Operation.stationState'),
                                prop: "state"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: formData.value.state,
                                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((formData.value.state) = $event)),
                                    clearable: ""
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(StationStates), (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          label: item.label,
                                          value: item.value,
                                          key: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                label: _unref(t)('Operation.streetCode'),
                                prop: "streetCode"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(ElInput), {
                                    modelValue: formData.value.streetCode,
                                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((formData.value.streetCode) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                label: _unref(t)('Operation.org'),
                                prop: "org"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(ElInput), {
                                    modelValue: formData.value.org,
                                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((formData.value.org) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                label: _unref(t)('Operation.meterAccount'),
                                prop: "meterAccount"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(ElInput), {
                                    modelValue: formData.value.meterAccount,
                                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((formData.value.meterAccount) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                label: _unref(t)('Operation.elecAccount'),
                                prop: "elecAccount"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(ElInput), {
                                    modelValue: formData.value.elecAccount,
                                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((formData.value.elecAccount) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                label: _unref(t)('Operation.buildTime'),
                                prop: "buildTime"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_date_picker, {
                                    modelValue: formData.value.buildTime,
                                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((formData.value.buildTime) = $event)),
                                    format: 'YYYY-MM-DD',
                                    type: "date"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["title"])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(SwitchLocaltionDialog, {
      modelValue: showMapsDialog.value,
      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((showMapsDialog).value = $event)),
      areaCode: formData.value.areaCode,
      lat: formData.value.lat,
      lng: formData.value.lng,
      onConfirm: handleChangeLatLng
    }, null, 8, ["modelValue", "areaCode", "lat", "lng"])
  ], 64))
}
}

})